module.exports = __webpack_public_path__ + "static/media/top-view-parents-spending-time-with-kids.a2d45ec3.png";